if (!customElements.get('innala-sugerencias')) {
  customElements.define('innala-sugerencias', class extends HTMLElement {
    connectedCallback() {
      const items = [...this.querySelectorAll('.innala-sugerencia')];
      if (!items.length) { this.hidden = true; return; }
      const barajar = (lista) => lista.map((x) => [Math.random(), x]).sort((a, b) => a[0] - b[0]).map((x) => x[1]);
      // Primero los que por sí solos completan el envío gratis, luego el resto
      const cierran = barajar(items.filter((i) => i.dataset.cierra === '1'));
      const resto = barajar(items.filter((i) => i.dataset.cierra !== '1'));
      [...cierran, ...resto].slice(0, 2).forEach((i) => { i.hidden = false; });
      this.addEventListener('click', (e) => this.agregar(e));
    }

    async agregar(e) {
      const btn = e.target.closest('[data-variante]');
      if (!btn) return;
      btn.disabled = true;
      const drawer = document.querySelector('cart-drawer');
      try {
        const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(btn.dataset.variante), quantity: 1 }],
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname,
          }),
        });
        if (!res.ok) throw new Error('No se pudo agregar');
        const state = await res.json();
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
        } else {
          window.location.reload();
        }
      } catch (err) {
        btn.disabled = false;
      }
    }
  });
}